import { render, staticRenderFns } from "./person_list.vue?vue&type=template&id=a734e4de&scoped=true&"
import script from "./person_list.vue?vue&type=script&lang=js&"
export * from "./person_list.vue?vue&type=script&lang=js&"
import style0 from "./person_list.vue?vue&type=style&index=0&id=a734e4de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a734e4de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a734e4de')) {
      api.createRecord('a734e4de', component.options)
    } else {
      api.reload('a734e4de', component.options)
    }
    module.hot.accept("./person_list.vue?vue&type=template&id=a734e4de&scoped=true&", function () {
      api.rerender('a734e4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_activity/components/person_list.vue"
export default component.exports